export default async function fetchJson(input, init = {}) {
  const { signal, ...rest } = init;

  const response = await fetch(input, {
    ...rest,
    ...(signal ? { signal } : {}),
  });

  const text = await response.text();
  let data = '';

  try {
    data = JSON.parse(text);
  } catch {
    data = text;
  }

  const { headers } = response;

  if (response.ok) {
    return { data, headers, response };
  }

  throw new FetchError({
    message: response.statusText,
    response,
    data,
  });
}

export class FetchError extends Error {
  constructor({ message, response, data }) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError);
    }

    this.name = 'FetchError';
    this.response = response;
    this.data = data ?? { message };

    this.bugSnagMetadata = [
      {
        label: 'response',
        fields: {
          url: response.url,
          headers: response.headers,
          statusText: response.statusText,
          status: response.status,
        },
      },
    ];
  }
}
